import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import PlacementPage from './pages/PlacementPage';
import MediaPage from './pages/MediaPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import CoursesPage from './pages/CoursesPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navbar />} >
          <Route index element={<HomePage />} />
          <Route path="/placements" element={<PlacementPage />} />
          <Route path="/media" element={<MediaPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/courses" element={<CoursesPage />} />
        </Route>
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
